export { default } from './FeaturedOfferCard';
